import React from "react";
import { useSelector } from "react-redux";
import UpdateStoreCart from "./UpdateStoreCart";
import {
    removeRegistrationStoreCartItem,
    selectAllRegistration,
    updateRegistrationStoreCart,
} from "../../../redux/slices/registrationSlice";
import {
    selectUpdated,
    setUpdated,
} from "../../../redux/slices/raceConditionsSlice";

const ConnectedUpdateStoreCart = () => {
    const { storeCart = [] } = useSelector(selectAllRegistration);
    const updated = useSelector(selectUpdated);
    const { storeData = [] } = updated;

    const updateStoreCartProps = {
        currentStoreCart: storeCart,
        updatedStoreData: storeData,
        setUpdated,
        updateRegistrationStoreCart,
        removeRegistrationStoreCartItem,
    };
    return <UpdateStoreCart {...updateStoreCartProps} />;
};

export default ConnectedUpdateStoreCart;
